import {Router} from '@angular/router';

export class RouterUtils {
    public static makeUrl(_url: string, options?: any) {
        let option = '';
        if (options === '' || options === undefined || options === {}) {
            option = '';
        }else {
            option = '/' + encodeURIComponent(JSON.stringify(options));
        }

        return `${_url}${option}`;
    }

    public static navigate(_route: Router, _url: string, options?: any) {
        //const option = (options === '') ? '' : '/' + JSON.stringify(options);
        /*let option = '';
        if(options === '' || options === undefined){
            option = '';
        }else {
            option = '/' + JSON.stringify(options);
        }*/
        const url = this.makeUrl(_url, options); // `${_url}${option}`;

        _route.navigate([url]);
        return false;
    }

    public static detect(url) {
        return JSON.parse(decodeURIComponent(url));
    }

    public static newWindow(_url: string, options?: any) {
        const url = this.makeUrl(_url, options);
        window.open(url);
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/src/router.utils.ts